/**
 * 档期模块接口
 */
import { _delete, _get, _post, _put } from '@/common/request';
// 获取档期管理月度总览
export function getMonthOverview(params) {
    return _get("/property/schedule/month", params, true);
}
// 获取单天视图数据
export function getDaySchedule(params) {
    return _get("/property/schedule/day", params, true);
}
// 获取不可订日期
export function getDisableDates(params) {
    return _get("/property/schedule/status", params, true);
}
// 获取有审核通过订单的日期
export function getApproveSchedule(params) {
    return _get("/property/schedule/dates", params, true);
}
// 获取展位列表筛选项
export function getBooths(params) {
    return _get("/property/booths", params, true);
}
// 获取展位不可订的日期
export function getBoothDisableCalendar(params) {
    return _get("/property/booths/" + params.id + "/calendars", params, true);
}
/*
* 设置展位不可订/可订日期
* @status: true 表示当前可订，设置不可订
*/
export function setBoothCalendar(params, status) {
    if (status)
        return _post("/property/booths/" + params.id + "/many_calendars", params, true);
    return _delete("/property/booths/" + params.id + "/many_calendars", params, true);
}
// 获取档期数据
// https://yapi.lanhanba.com/project/47/interface/api/25850
export function getScheduleData(params) {
    return _post("/property/schedule/home", params, true);
}
// 锁定档期
// https://yapi.lanhanba.com/project/47/interface/api/25830
export function lockSchedule(params) {
    return _post("/property/booth_occupations/lock", params, true);
}
// 取消锁定档期
// https://yapi.lanhanba.com/project/47/interface/api/25885
export function cancelLockSchedule(id) {
    return _delete("/property/booth_occupations/unlock/" + id, null, true);
}
// 获取锁定详情
// https://yapi.lanhanba.com/project/47/interface/api/27141
export function getLockDetail(id) {
    return _get("/property/booth_occupations/detail/" + id, null, true);
}
// 预定档期
// https://yapi.lanhanba.com/project/47/interface/api/25840
export function orderSchedule(params) {
    return _post("/property/orders/calendar", params, true);
}
// 获取今日待办列表
// https://yapi.lanhanba.com/project/47/interface/api/26885
export function getToDoData(params) {
    return _get("/property/schedule/to_do", params, true);
}
// 获取tab栏数据
// https://yapi.lanhanba.com/project/47/interface/api/28429
export function getTabCount(params) {
    return _get("/property/schedule/tab_count", params, true);
}
// 新增预锁线索
// https://yapi.lanhanba.com/project/319/interface/api/37582
export function addProLockClue(params) {
    return _post("/property/schedule/pre_lock_clue", params, true);
}
// 新增意向线索
// https://yapi.lanhanba.com/project/319/interface/api/37575
export function addIntentionClue(params) {
    return _post("/property/schedule/intention_clue", params, true);
}
// 是否有空闲档期检查
// https://yapi.lanhanba.com/project/319/interface/api/37687
export function checkSchedule(params) {
    return _get("/property/schedule/check", params, true);
}
/**
 * 项目列表（带展位）
 * https://yapi.lanhanba.com/project/319/interface/api/41306
 */
export function getStopWithBooth(params) {
    return _post("/property/shops/shop_with_booth", params, true);
}
/**
 * 创建线索
 * https://yapi.lanhanba.com/project/319/interface/api/41502
 */
export function postClue(params) {
    return _post("/property/clue", params, true);
}
/**
 * 创建单展位线索（在档期视图内操作）
 * https://yapi.lanhanba.com/project/319/interface/api/41502
 */
export function postSingleClue(params) {
    return _post("/property/clue_single", params, true);
}
/**
 * 落档冲突列表
 * https://yapi.lanhanba.com/project/319/interface/api/41313
 */
export function getClueConflicts(params) {
    return _get("/property/clue/conflicts", params, true);
}
/** TODO: 请求地址需要更换， 更换后请删除注释 */
export function addClue(params) {
    return _get("/property/clue/conflicts", params, true);
}
/**
 * 线索卡片详情
 * https://yapi.lanhanba.com/project/319/interface/api/42181
 */
export function getClueDetailInfo(params) {
    return _get("/property/clue_detail/" + params.id, params, true);
}
/**
 * 修改线索卡片
 * https://yapi.lanhanba.com/project/319/interface/api/41999
 */
export function putClueDetail(params) {
    return _put("/property/clue_detail/" + params.id, params, true);
}
/**
 * 创建分享档期
 * https://yapi.lanhanba.com/project/319/interface/api/42517
 */
export function getShareScheduleUrl(params) {
    return _post("/property/schedule/shares", params, true);
}
/**
 * 查询分享档期
 * https://yapi.lanhanba.com/project/319/interface/api/42524
 */
export function getShareScheduleData(id) {
    return _get("/property/schedule/shares/" + id, null, true);
}
/**
 * 导出档期
 * https://yapi.lanhanba.com/project/319/interface/api/41999
 */
export function exportSchedule(params) {
    return _post("/property/schedule/export", params, true);
}
// 获取档期到期提醒
// https://yapi.lanhanba.com/project/319/interface/api/43728
export function getExpirationReminder(params) {
    return _post("/property/schedule/expiration_reminder", params, true);
}
// 获取线索状态选项
// https://yapi.lanhanba.com/project/319/interface/api/61977
export function getClueStatusOptions() {
    return _post('/property/activityPermissions', null);
}
